import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";

const DOC_TYPES = ["Transport Bilty", "E-Way Bill", "Transporter Invoice", "Other"];

export default function TripDocumentDialog({ tripId, onClose, onSaved }) {
  const [documentType, setDocumentType] = useState("Transport Bilty");
  const [label, setLabel] = useState("");
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Please select a file");
    if (documentType === "Other" && !label.trim()) return toast.error("Label is required when Document Type is 'Other'");
    setSaving(true);
    const fd = new FormData();
    fd.append("document_type", documentType);
    if (label.trim()) fd.append("label", label.trim());
    fd.append("file", file);
    try {
      await client.post(`/transport-log/trips/${tripId}/documents`, fd);
      toast.success("Document added");
      onSaved();
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md" data-testid="trip-document-dialog">
        <DialogHeader>
          <DialogTitle>Add Trip Document</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Document Type</label>
            <Select value={documentType} onValueChange={setDocumentType}>
              <SelectTrigger data-testid="trip-document-type-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {DOC_TYPES.map((t) => (
                  <SelectItem key={t} value={t} data-testid={`trip-document-type-option-${t}`}>
                    {t}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          {documentType === "Other" && (
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Label *</label>
              <Input data-testid="trip-document-label-input" value={label} onChange={(e) => setLabel(e.target.value)} />
            </div>
          )}
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">File (PDF, JPG, PNG) *</label>
            <Input type="file" accept=".pdf,image/jpeg,image/png" data-testid="trip-document-file-input" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} data-testid="trip-document-cancel-button">
              Cancel
            </Button>
            <Button type="submit" disabled={saving} data-testid="trip-document-submit-button" className="bg-amber-600 hover:bg-amber-700">
              {saving ? "Uploading..." : "Add Document"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
